import axios from "axios";
import { IWidgetResponse } from "../Base/Base.types";
import { IOnTimeArrival } from "./OnTimeArrival.types";

export default class OnTimeArrivalApi {
	static async getData({ queryKey }: any) {
		//eslint-disable-next-line
		const [_, rawQuery] = queryKey;

		try {
			let res = await axios.get(`/V2/OnTimeArrival`, { params: rawQuery });
			return res.data as IWidgetResponse<IOnTimeArrival>;
		} catch (e: any) {
			console.error('Could not get OnTimeArrival data: ', e.message);
			return undefined;
		}
	}
}